import dateFns from 'date-fns/locale/sr-Latn';

export default {
  dateFns,

  format: {
    date: 'd.M.yyyy.',
    time: 'p',
    dateTime: '$t(format:date) $t(format:time)',
    longDate: 'd. MMM',
    longDateTime: "d. MMMM 'u' p",
    fullDate: 'd. MMM y',
    fullDateTime: "d. MMMM y 'u' p",
  },

  translation: {
    common: {
      aboutPlanka: 'O Planka',
      account: 'Nalog',
      actions: 'Radnje',
      addAttachment_title: 'Dodaj prilog',
      addComment: 'Dodaj komentar',
      addManager_title: 'Dodaj rukovodioca',
      addMember_title: 'Dodaj člana',
      addUser_title: 'Dodaj korisnika',
      administrator: 'Administrator',
      all: 'Sve',
      allChangesWillBeAutomaticallySavedAfterConnectionRestored:
        'Sve promene će automatski biti sačuvane<br />nakon uspostavljanja konekcije.',
      areYouSureYouWantToDeleteThisAttachment: 'Da li zaista želite da obrišete ovaj prilog?',
      areYouSureYouWantToDeleteThisBoard: 'Da li zaista želite da obrišete ovu tablu?',
      areYouSureYouWantToDeleteThisCard: 'Da li zaista želite da obrišete ovu karticu?',
      areYouSureYouWantToDeleteThisComment: 'Da li zaista želite da obrišete ovaj komentar?',
      areYouSureYouWantToDeleteThisLabel: 'Da li zaista želite da obrišete ovu oznaku?',
      areYouSureYouWantToDeleteThisList: 'Da li zaista želite da obrišete ovaj spisak?',
      areYouSureYouWantToDeleteThisProject: 'Da li zaista želite da obrišete ovaj projekat?',
      areYouSureYouWantToDeleteThisTask: 'Da li zaista želite da obrišete ovaj zadatak?',
      areYouSureYouWantToDeleteThisUser: 'Da li zaista želite da obrišete ovog korisnika?',
      areYouSureYouWantToLeaveBoard: 'Da li zaista želite da napustite ovu tablu?',
      areYouSureYouWantToLeaveProject: 'Da li zaista želite da napustite ovaj projekat?',
      areYouSureYouWantToRemoveThisManagerFromProject:
        'Da li zaista želite da uklonite ovog rukovodioca iz ovog projekta?',
      areYouSureYouWantToRemoveThisMemberFromBoard:
        'Da li zaista želite da uklonite ovog člana iz ove table?',
      attachment: 'Prilog',
      attachments: 'Prilozi',
      authentication: 'Autentifikacija',
      background: 'Pozadina',
      board: 'Tabla',
      boardNotFound_title: 'Tabla nije pronađena',
      canComment: 'Može da komentariše',
      canEditContentOfBoard: 'Može da uređuje sadržaj table.',
      canOnlyViewBoard: 'Može samo da pregleda tablu.',
      cardActions_title: 'Radnje nad karticom',
      cardNotFound_title: 'Kartica nije pronađena',
      cardOrActionAreDeleted: 'Kartica ili radnja su obrisane.',
      color: 'Boja',
      copy_inline: 'kopija',
      createBoard_title: 'Napravi tablu',
      createLabel_title: 'Napravi oznaku',
      createNewOneOrSelectExistingOne: 'Napravi novu ili izaberi<br />postojeću.',
      createProject_title: 'Napravi projekat',
      createTextFile_title: 'Napravi tekstualnu datoteku',
      currentPassword: 'Trenutna lozinka',
      dangerZone_title: 'Opasna zona',
      date: 'Datum',
      dueDate: 'Rok',
      dueDate_title: 'Rok',
      deleteAttachment_title: 'Obriši prilog',
      deleteBoard_title: 'Obriši tablu',
      deleteCard_title: 'Obriši karticu',
      deleteComment_title: 'Obriši komentar',
      deleteLabel_title: 'Obriši oznaku',
      deleteList_title: 'Obriši spisak',
      deleteProject_title: 'Obriši projekat',
      deleteTask_title: 'Obriši zadatak',
      deleteUser_title: 'Obriši korisnika',
      description: 'Opis',
      detectAutomatically: 'Detektuj automatski',
      dropFileToUpload: 'Prevuci datoteku za slanje',
      editor: 'Uređivač',
      editAttachment_title: 'Uredi prilog',
      editAvatar_title: 'Uredi avatara',
      editBoard_title: 'Uredi tablu',
      editDueDate_title: 'Uredi rok',
      editEmail_title: 'Uredi e-poštu',
      editInformation_title: 'Uredi informacije',
      editLabel_title: 'Uredi oznaku',
      editPassword_title: 'Izmeni lozinku',
      editPermissions_title: 'Uredi ovlašćenja',
      editStopwatch_title: 'Uredi štopericu',
      editUsername_title: 'Izmeni korisničko ime',
      email: 'E-pošta',
      emailAlreadyInUse: 'E-pošta je već u upotrebi',
      enterCardTitle: 'Unesi naslov kartice... [Ctrl+Enter] da se automatski otvori.',
      enterDescription: 'Unesi opis...',
      enterFilename: 'Unesi naziv datoteke',
      enterListTitle: 'Unesi naslov spiska...',
      enterProjectTitle: 'Unesi naslov projekta',
      enterTaskDescription: 'Unesi opis zadatka...',
      filterByLabels_title: 'Filtriraj prema oznakama',
      filterByMembers_title: 'Filtriraj prema članovima',
      fromComputer_title: 'Sa računara',
      fromTrello: 'Sa Trello-a',
      general: 'Opšte',
      hours: 'Sati',
      importBoard_title: 'Uvezi tablu',
      invalidCurrentPassword: 'Neispravna trenutna lozinka',
      labels: 'Oznake',
      language: 'Jezik',
      leaveBoard_title: 'Napusti tablu',
      leaveProject_title: 'Napusti projekat',
      linkIsCopied: 'Veza je iskopirana',
      list: 'Spisak',
      listActions_title: 'Radnje nad spiskom',
      managers: 'Rukovodioci',
      managerActions_title: 'Radnje nad rukovodiocima',
      members: 'Članovi',
      memberActions_title: 'Radnje nad članovima',
      minutes: 'Minuti',
      moveCard_title: 'Premesti karticu',
      name: 'Ime',
      newestFirst: 'Prvo najnovije',
      newEmail: 'Nova e-pošta',
      newPassword: 'Nova lozinka',
      newUsername: 'Novo korisničko ime',
      noConnectionToServer: 'Nema konekcije sa serverom',
      noBoards: 'Nema tabli',
      noLists: 'Nema spiskova',
      noProjects: 'Nema projekata',
      notifications: 'Obaveštenja',
      noUnreadNotifications: 'Nema nepročitanih obaveštenja.',
      oldestFirst: 'Prvo najstarije',
      openBoard_title: 'Otvori tablu',
      optional_inline: 'opciono',
      organization: 'Organizacija',
      phone: 'Telefon',
      preferences: 'Svojstva',
      pressPasteShortcutToAddAttachmentFromClipboard:
        'Savet: pritisni Ctrl-V (Cmd-V na Meku) da bi dodao prilog sa beležnice.',
      project: 'Projekat',
      projectNotFound_title: 'Projekat nije pronađen',
      removeManager_title: 'Ukloni rukovodioca',
      removeMember_title: 'Ukloni člana',
      searchLabels: 'Pretraži oznake...',
      searchMembers: 'Pretraži članove...',
      searchUsers: 'Pretraži korisnike...',
      searchCards: 'Pretraži kartice...',
      seconds: 'Sekunde',
      selectBoard: 'Izaberi tablu',
      selectList: 'Izaberi spisak',
      selectPermissions_title: 'Izaberi odobrenja',
      selectProject: 'Izaberi projekat',
      settings: 'Podešavanja',
      sortList_title: 'Složi spisak',
      stopwatch: 'Štoperica',
      subscribeToMyOwnCardsByDefault: 'Podrazumevano se pretplati na sopstvene kartice',
      taskActions_title: 'Radnje nad zadatkom',
      tasks: 'Zadaci',
      thereIsNoPreviewAvailableForThisAttachment: 'Nema pregleda dostupnog za ovaj prilog.',
      time: 'Vreme',
      title: 'Naslov',
      userActions_title: 'Korisničke radnje',
      userAddedThisCardToList: '<0>{{user}}</0><1> je dodao ovu karticu na {{list}}</1>',
      userLeftNewCommentToCard: '{{user}} je ostavio novi komentar «{{comment}}» u <2>{{card}}</2>',
      userMovedCardFromListToList:
        '{{user}} je premestio <2>{{card}}</2> sa {{fromList}} u {{toList}}',
      userMovedThisCardFromListToList:
        '<0>{{user}}</0><1> je premestio ovu karticu sa {{fromList}} na {{toList}}</1>',
      username: 'Korisničko ime',
      usernameAlreadyInUse: 'Korisničko ime je već u upotrebi',
      users: 'Korisnici',
      version: 'Verzija',
      viewer: 'Pregledač',
      writeComment: 'Napiši komentar...',
    },

    action: {
      addAnotherCard: 'Dodaj još jednu karticu',
      addAnotherList: 'Dodaj još jedan spisak',
      addAnotherTask: 'Dodaj još jedan zadatak',
      addCard: 'Dodaj karticu',
      addCard_title: 'Dodaj karticu',
      addComment: 'Dodaj komentar',
      addList: 'Dodaj spisak',
      addMember: 'Dodaj člana',
      addMoreDetailedDescription: 'Dodaj detaljniji opis',
      addTask: 'Dodaj zadatak',
      addToCard: 'Dodaj na karticu',
      addUser: 'Dodaj korisnika',
      copyLink_title: 'Kopiraj vezu',
      createBoard: 'Napravi tablu',
      createFile: 'Napravi datoteku',
      createLabel: 'Napravi oznaku',
      createNewLabel: 'Napravi novu oznaku',
      createProject: 'Napravi projekat',
      delete: 'Obriši',
      deleteAttachment: 'Obriši prilog',
      deleteAvatar: 'Obriši avatara',
      deleteBoard: 'Obriši tablu',
      deleteCard: 'Obriši karticu',
      deleteCard_title: 'Obriši karticu',
      deleteComment: 'Obriši komentar',
      deleteImage: 'Obriši sliku',
      deleteLabel: 'Obriši oznaku',
      deleteList: 'Obriši spisak',
      deleteList_title: 'Obriši spisak',
      deleteNotifications: 'Dismiss all',
      deleteProject: 'Obriši projekat',
      deleteProject_title: 'Obriši projekat',
      deleteTask: 'Obriši zadatak',
      deleteTask_title: 'Obriši zadatak',
      deleteUser: 'Obriši korisnika',
      duplicate: 'Kloniraj',
      duplicateCard_title: 'Kloniraj karticu',
      edit: 'Izmeni',
      editDueDate_title: 'Izmeni rok',
      editDescription_title: 'Izmeni opis',
      editEmail_title: 'Izmeni e-poštu',
      editInformation_title: 'Izmeni informacije',
      editPassword_title: 'Izmeni lozinku',
      editPermissions: 'Izmeni odobrenja',
      editStopwatch_title: 'Izmeni štopericu',
      editTitle_title: 'Izmeni naslov',
      editUsername_title: 'Izmeni korisničko ime',
      hideDetails: 'Sakrij detalje',
      import: 'Uvezi',
      leaveBoard: 'Napusti tablu',
      leaveProject: 'Napusti projekat',
      logOut_title: 'Odjava',
      makeCover_title: 'Napravi omot',
      move: 'Premesti',
      moveCard_title: 'Premesti karticu',
      remove: 'Ukloni',
      removeBackground: 'Ukloni pozadinu',
      removeCover_title: 'Ukloni omot',
      removeFromBoard: 'Ukloni sa table',
      removeFromProject: 'Ukloni iz projekta',
      removeManager: 'Ukloni rukovodioca',
      removeMember: 'Ukloni člana',
      save: 'Sačuvaj',
      showAllAttachments: 'Prikaži sve ({{hidden}} sakrivene priloge)',
      showDetails: 'Prikaži detalje',
      showFewerAttachments: 'Prikaži manje priloga',
      sortList_title: 'Složi spisak',
      start: 'Počni',
      stop: 'Zaustavi',
      subscribe: 'Pretplati se',
      unsubscribe: 'Ukini pretplatu',
      uploadNewAvatar: 'Postavi novi avatar',
      uploadNewImage: 'Postavi novu sliku',
    },
  },
};
